import _ from 'underscore'
import op from 'object-path'

import CONSTANT from '../constant/cookie'
import cookie from '../lib/cookie'
import config from './config'

const co = cookie(CONSTANT.COOKIE_CO)
const theme = op(_.assign({}, config.defaults, config[co] || config.defaults))
theme.tpl = (template) => {
  return text.replace(/\{\{\s*(.+?)\s*\}\}/g, function (matched, word) {
    return theme.get(word) || matched;
  });
}
export default theme
